import initialState from './state';

import {
  PENDING_STATUS,
  UNDEFINED_STATUS
} from './action-status';

import {
  RESET_STATE,
  SET_LINK_CIPHER,
  SET_ACTIVE_SHARED_VIEW,
  SET_APP_TYPE,
  SET_LINK_TYPE,
  SET_LINK_DETAILS,
  SET_FETCH_LINK_DETAILS_STATUS,
  SET_LINK_PASSWORD,
  SET_SETUP_LINK_PASSWORD_STATUS,
  SET_LINK_RESTORE_INFO,
  SET_FETCH_LINK_RESTORE_INFO_STATUS,
  SET_LINK_CONTENT_ITEMS,
  SET_FETCH_LINK_CONTENT_ITEMS_STATUS,
  SET_LINK_ROOT_FOLDER_NAME
} from './mutation-types';

function isNeedChangeStatus(status, newStatus) {
  if (status === UNDEFINED_STATUS) {
    return newStatus === PENDING_STATUS;
  }
  return true;
}

export default {
  [RESET_STATE](state) {
    Object.assign(state, initialState());
  },
  [SET_LINK_CIPHER](state, linkCipher) {
    state.linkCipher = linkCipher;
  },
  [SET_ACTIVE_SHARED_VIEW](state, activeSharedView) {
    state.activeSharedView = activeSharedView;
  },
  [SET_APP_TYPE](state, appType) {
    state.appType = appType;
  },
  [SET_LINK_TYPE](state, linkType) {
    state.linkType = linkType;
  },
  [SET_LINK_DETAILS](state, linkDetails) {
    state.linkDetails = linkDetails;
  },
  [SET_FETCH_LINK_DETAILS_STATUS](state, status) {
    if (isNeedChangeStatus(state.fetchLinkDetailsStatus, status)) {
      state.fetchLinkDetailsStatus = status;
    }
  },
  [SET_LINK_PASSWORD](state, linkPassword) {
    state.linkPassword = linkPassword;
  },
  [SET_SETUP_LINK_PASSWORD_STATUS](state, status) {
    if (isNeedChangeStatus(state.setupLinkPasswordStatus, status)) {
      state.setupLinkPasswordStatus = status;
    }
  },
  [SET_LINK_RESTORE_INFO](state, linkRestoreInfo) {
    state.linkRestoreInfo = linkRestoreInfo;
  },
  [SET_FETCH_LINK_RESTORE_INFO_STATUS](state, status) {
    if (isNeedChangeStatus(state.fetchLinkRestoreInfoStatus, status)) {
      state.fetchLinkRestoreInfoStatus = status;
    }
  },
  [SET_LINK_CONTENT_ITEMS](state, linkContentItems) {
    state.linkContentItems = linkContentItems;
  },
  [SET_FETCH_LINK_CONTENT_ITEMS_STATUS](state, status) {
    if (isNeedChangeStatus(state.fetchLinkContentItemsStatus, status)) {
      state.fetchLinkContentItemsStatus = status;
    }
  },
  [SET_LINK_ROOT_FOLDER_NAME](state, rootFolderName) {
    state.rootFolderName = rootFolderName;
  }
};

